import React from 'react';
import Footer from './Footer';
import Header from './Header';
import Pop from './Pop';

import { Container, CssBaseline } from '@material-ui/core';
const ErrorTechnique = () => {
  
  return (
    <>
      <CssBaseline />
      <Header />
      <Container maxWidth="lg">

        <Pop />
      </Container>
      <Footer />
    </>);
};
export default ErrorTechnique;
